"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadWasmInstance = void 0;
/**
 * Webpack File-loader will break when the extension is .wasm.
 * Changing the extension is a workaround. And because of this
 * |instantiateStreaming| is always failed due to wrong MIME type.
 * see https://github.com/webpack/webpack/issues/6725
 */
// import wasmBinaryFile from './zbar.wasm';

var zbar_wasm_bin_1 = __importDefault(require("./zbar.wasm.bin"));

exports.loadWasmInstance = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(importObj) {
    var res, binary, output;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(zbar_wasm_bin_1.default);

          case 2:
            res = _context.sent;

            if (res['ok']) {
              _context.next = 6;
              break;
            }

            console.error('Failed to load wasm binary file at ' + zbar_wasm_bin_1.default);
            return _context.abrupt("return", null);

          case 6:
            _context.next = 8;
            return res.arrayBuffer();

          case 8:
            binary = _context.sent;
            _context.next = 11;
            return WebAssembly.instantiate(binary, importObj);

          case 11:
            output = _context.sent;
            return _context.abrupt("return", output.instance);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();